import React from 'react';

import { HiOutlineTrash } from 'react-icons/hi';
import { IDeleteBtn } from '../../interfaces/components/button.interface';

const DeleteBtn = ({ callback, classname, disabled }: IDeleteBtn) => {
  return (
    <div className="relative">
      {disabled && (
        <div className="w-full h-full bg-gray-300 absolute top-0 left-0 opacity-60 z-20 rounded-xl cursor-not-allowed"></div>
      )}
      <button
        className={`flex items-center justify-between p-3 bg-blur_red rounded-xl text-primary_red ${classname}`}
        onClick={() => !disabled && callback()}
      >
        <HiOutlineTrash className="mr-2 text-primary_red h-8" />
        Xoá
      </button>
    </div>
  );
};

export default DeleteBtn;
